import type {Cell} from '../../../../hooks/tanstack-table/helpers/types'
import type {TableDataType} from '../../table-data-type'
import type {ClipboardState} from './types'

type Props = {
  cell: Pick<Cell<TableDataType>, 'column' | 'row'>
  clipboard: ClipboardState
}

export const isCellCopySourceForClipboard = ({cell, clipboard}: Props) => {
  if (clipboard.type === 'empty') return false
  if (clipboard.hideCopyOutline) return false
  if (!clipboard.copiedCells) return false

  const clipboardCell = clipboard.copiedCells.get(cell.row.original.id)
  if (!clipboardCell) return false
  return clipboardCell.columnId === cell.column.id
}
